// ** Third Party Components
import styled from "styled-components";

export const ButtonGroup = styled.div`
	display: flex;
	button:not(:first-child) {
		margin-left: 4.2px;
		border-top-left-radius: 0;
		border-bottom-left-radius: 0;
	}
	button:not(:last-child) {
		margin-right: 0;
		border-top-right-radius: 0;
		border-bottom-right-radius: 0;
	}
	button {
		flex: 1;
	}
`;
